import { useEffect } from 'react';

const DEFAULT_FAVICON = '/favicon.ico';

/**
 * ファビコンを動的に切り替えるフック
 * @param faviconUrl ファビコンのURL（省略時はデフォルト）
 */
export function useFavicon(faviconUrl?: string) {
  useEffect(() => {
    const url = faviconUrl || DEFAULT_FAVICON;
    const link = document.querySelector<HTMLLinkElement>("link[rel*='icon']");

    if (link) {
      link.href = url;
    } else {
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = url;
      document.head.appendChild(newLink);
    }

    return () => {
      // クリーンアップ時にデフォルトに戻す
      const currentLink = document.querySelector<HTMLLinkElement>("link[rel*='icon']");
      if (currentLink) {
        currentLink.href = DEFAULT_FAVICON;
      }
    };
  }, [faviconUrl]);
}
